import React from 'react';

import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

import axiosInstance from '../config/axiosConfig';

import i18next from 'i18next';

const t = (i18nKey, params) => i18next.t(`userDashboard.layout.welcome_dialog.${i18nKey}`, params);

const WelcomeDialog = ({ isVisible, onClose }) => {

    const handleWelcomeDialogClose = () => {
        axiosInstance.post('/dashboard/user/me/welcomeMessage').then(() => {
            onClose();
        }).catch(error => {
            console.error('Error updating welcome message:', error);
        });
    };

    return (
        <Dialog
            header="Bienvenue"
            visible={isVisible}
            modal
            onHide={handleWelcomeDialogClose}
            closeOnEscape={false}
            closable={false}
            style={{ width: '50vw' }}>

            <div dangerouslySetInnerHTML={{ __html: t('content') }} />

            <div className="mt-4">
                <Button label={t('button_label')} onClick={handleWelcomeDialogClose} autoFocus />
            </div>

        </Dialog>
    );
};

export default WelcomeDialog;